import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'arraySubAreaCardMoveUp',
    position: [ButtonPosition.arraySubAreaCardOperate],
    action: (config) => {
        const { arrayBaseField, arrayBaseFieldIndex } = config || {};
        if (arrayBaseField) {
            if (arrayBaseField?.disabled === true ||
                arrayBaseField?.pattern !== 'editable') {
                return;
            }
            arrayBaseField?.moveUp(arrayBaseFieldIndex);
        }
    },
};
